<template>
  <el-dialog
    title="事项管理"
    :visible.sync="dialogVisible"
    width="680px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form :model="formInline" ref="form" label-width="140px">
        <el-form-item label="事项名称">
          <el-input
            style="width: 356px;"
            v-model="formInline.sxmc"
            placeholder="事项名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属模块">
          <el-select
            filterable
            placeholder="请选择所属模块"
            clearable
            v-model="formInline.extendClient"
          >
            <el-option
              v-for="item in extendClientOptions"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch
            v-model="formInline.state"
            active-value="是"
            inactive-value="否"
            active-color="#0495FF"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="主办部门">
          <el-select
            style="width: 356px;"
            v-model="formInline.tjDeptId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否授权社区可管理">
          <el-radio-group v-model="formInline.zsSqUseFlag">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="eventEditFun">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getDeptTree } from "@/api/systemManagement.js";
import { mangerEdit } from "@/api/onDutyAndStandBy.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formInline: {
        state: "",
        sxmc: "",
        extendClient: "",
        id: "",
        tjDeptId: "",
        zsSqUseFlag: ""
      },
      deptList: [],
      extendClientOptions: [
        {
          text: "关芯客服",
          value: "关芯客服"
        },
        {
          text: "关芯智巡",
          value: "关芯智巡"
        }
      ]
    };
  },
  created() {
    this.formInline = JSON.parse(JSON.stringify(this.curItem));
    this.getTree();
  },
  mounted() {},
  methods: {
    // 获取部门资源树形
    async getTree() {
      let params = {
        page: 999,
        size: 1,
        pid: "2000000035",
        data: true
      };
      const res = await getDeptTree(params);
      if (res.data.code == 200) {
        this.deptList = res.data.data;
      }
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async eventEditFun() {
      let params = {
        state: this.formInline.state,
        extendClient: this.formInline.extendClient,
        sxmc: this.formInline.sxmc,
        tjDeptId: this.formInline.tjDeptId,
        id: this.formInline.id,
        ghEventTypeId: "id_zhishou",
        zsSqUseFlag: this.formInline.zsSqUseFlag
      };
      const res = await mangerEdit(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-input {
  width: 340px !important;
}
/deep/.el-upload__input {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/standBy/components/issuesDialog.vue